/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
} from './UserDto';

/**
 * 
 * @export
 * @interface UsersDto
 */
export interface UsersDto {
    /**
     * The users.
     * @type {Array<UserDto>}
     * @memberof UsersDto
     */
    items: Array<UserDto>;
    /**
     * The total number of users.
     * @type {number}
     * @memberof UsersDto
     */
    total: number;
}

/**
 * Check if a given object implements the UsersDto interface.
 */
export function instanceOfUsersDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function UsersDtoFromJSON(json: any): UsersDto {
    return UsersDtoFromJSONTyped(json, false);
}

export function UsersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(UserDtoFromJSON)),
        'total': json['total'],
    };
}

export function UsersDtoToJSON(value?: UsersDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(UserDtoToJSON)),
        'total': value.total,
    };
}

